import h from 'hyperscript';

import managementCenterIcon from '@disy/cadenza-icons/management-center.svg';
import settingsIcon from '@disy/cadenza-icons/settings.svg';
import { array } from '@disy/lib/array-util';
import { createIconButtonAnchor } from '@disy/ui/anchor';
import { createIconButton } from '@disy/ui/button';
import type { Content } from '@disy/ui/content';
import { icon } from '@disy/ui/icon';
import { vr } from '@disy/ui/separator';

import './resource-summary.css';

const COMPONENT_NAME = 'd-resource-summary';

export function createResourceSummary(header: Content, metaLabels: (string | Node)[], options?: HeadlineOptions) {
  const manageObjecttypeButtion = createManageObjecttypeButton(options);
  return createResourceSummaryContainer([
    h('.h1.d-resource-summary--headline', [...array(header), manageObjecttypeButtion && manageObjecttypeButtion]),
    createResourceMetaLabel(metaLabels),
  ]);
}

function createResourceSummaryContainer(content: HTMLElement[]) {
  return h(`.${COMPONENT_NAME}.d-stack-v.space-2`, content);
}

export interface HeadlineOptions {
  managementCenterLink?: {
    label: string;
    url: string;
  };
  manageObjecttypeAction?: {
    execute: () => Promise<void>;
    label: string;
  };
}

function createManageObjecttypeButton(options?: HeadlineOptions) {
  if (options && options.managementCenterLink) {
    return createIconButtonAnchor(
      icon(managementCenterIcon),
      options.managementCenterLink.label,
      options.managementCenterLink.url,
      {
        target: '_blank',
        styleClass: ['d-resource-summary--headline-settings-button', 'button-link', 'button-s'],
      },
    );
  }
  if (options && options.manageObjecttypeAction) {
    return createIconButton(icon(settingsIcon), options.manageObjecttypeAction.label, {
      size: 's',
      styleClass: ['d-resource-summary--headline-settings-button', 'button-icon'],
      variant: 'link',
      onclick: options.manageObjecttypeAction.execute,
    });
  }
}

function createResourceMetaLabel(elements: (Node | string)[]) {
  return h(
    '.d-resource-summary--meta-label.d-stack-h.space-1',
    elements
      .flatMap((x) => {
        return [vr(), x];
      })
      .slice(1),
  ); // drop first unnecessary vr()
}
